import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import classess from './style.module.css';

export default () => {
	const emailFastFieldElement = document.querySelector('.field-fastregistrationform-email');
	const emailFieldElement = document.querySelector('.field-registrationform-email');

	const middleNameFieldElement = document.querySelector('.field-registrationform-middle');
	const middleNameFastFieldElement = document.querySelector('.field-fastregistrationform-middle');

	emailFastFieldElement ? addEmailNotice(emailFastFieldElement) : '';
	emailFieldElement ? addEmailNotice(emailFieldElement) : '';
	middleNameFieldElement ? addMiddleNameNotice(middleNameFieldElement) : '';
	middleNameFastFieldElement ? addMiddleNameNotice(middleNameFastFieldElement) : '';
	
	return;
	
	function addEmailNotice (field) {
		const noticeElement = document.createElement('p');
		const noticeText = translator.t('main', 'Check email');
	
		noticeElement.classList.add(classess.emailNotice);
		noticeElement.textContent = noticeText;
		field.append(noticeElement);
	}

	function addMiddleNameNotice (field) {
		const noticeElement = document.createElement('p');
		const noticeText = translator.t('main', 'We recommend specifying if available');
	
		noticeElement.classList.add(classess.emailNotice);
		noticeElement.textContent = noticeText;
		field.append(noticeElement);
	}
};
